<template>
  <a-card :bordered="false">
    <a-tabs defaultActiveKey="1">
      <!-- 业绩拆分录入 -->
      <a-tab-pane tab="业绩拆分" key="1">
        <a-card title="原始业绩信息">
          <a-form :form="originalForm" layout="horizontal">
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="投保人" :labelCol="labelCol" :wrapperCol="wrapperCol" :help="insureTip">
                  <a-dropdown  :trigger="['click']" placement="bottomLeft">
                    <a-input-search allowClear v-decorator="['insure', {rules: [{required: true, message: '请选择投保人'}]}]"
                                    @input="insureInput" @search="insureSearch"
                                    @focus="insureInputFocus" @blur="insureBlur">
                    </a-input-search>
                    <a-menu v-if="insureDropDownList.length > 0" slot="overlay">
                      <a-menu-item v-for="(item,index) in insureDropDownList" :key="item">
                        <span @click="insureChange(item)">{{item}}</span>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="项目组" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list" v-decorator="['project', {rules: [{required: true, message: '请选择项目组'}]}]"
                                     :trigger-change="true" dictCode="bms_project" placeholder="请选择项目组"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="所属部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入所属部门" v-decorator="['department', {rules: [{required: true, message: '请输入所属部门'}]}]" disabled />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="立项名称" :labelCol="labelCol" :wrapperCol="wrapperCol" :required="currentBusinessType === '0'">
                  <j-search-select-tag placeholder="立项名称"
                                       v-decorator="['projectInfoId', {rules: [{required: false}]}]"
                                       :trigger-change="true" dict="proj_project,name,id" :async="true" disabled/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="二级单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-search-select-tag placeholder="二级单位"
                                       v-decorator="['insureParentOrg', {rules: [{required: false, message: '请选择二级单位'}]}]"
                                       :trigger-change="true" dict="biz_customer,name,id" :async="true" disabled/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="开票单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    v-decorator="[ 'invoiceUnit', {rules: [{required: true, message: '请选择开票单位'}]}]"
                    placeholder="请选择开票单位"
                    :getPopupContainer="(target) => target.parentNode">
                    <a-select-option v-for="(item) in invoiceUnits" :value="item.orgCode" :key="item.orgCode">{{ item.departName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="被保险人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入被保险人" v-decorator="['insured', {rules: [{required: true, message: '请输入被保险人'}]}]" />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="上报类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    v-decorator="[ 'reportType', {rules: [{required: true, message: '请选择上报类型'}]}]"
                    placeholder="请选择上报类型"
                    :getPopupContainer="(target) => target.parentNode">
                    <a-select-option value="0">报送</a-select-option>
                    <a-select-option value="1">报备</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="业务类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-dict-select-tag type="list"
                                     v-decorator="['businessType', {rules: [{required: true, message: '请选择业务类型'}]}]"
                                     :trigger-change="true"
                                     :options="businessTypeDict"
                                     placeholder="请选择业务类型" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-card>
        <a-card title="拆分设置" style="margin-top: 20px;">
          <div style="margin-bottom: 10px;">
            <a-button @click="toggleInsuranceTypeTable" :type="showInsuranceTypeTable ? 'primary' : 'default'" size="small" style="margin-right: 5px;">险种</a-button>
            <a-button type="primary" size="small" style="margin-right: 5px;">保险公司</a-button>
            <a-button @click="togglePeriodTable" :type="showPeriodTable ? 'primary' : 'default'" size="small" style="margin-right: 5px;">期数</a-button>
          </div>

          <!-- 险种表格 - 上 -->
          <div class="table-wrapper" v-if="showInsuranceTypeTable" data-title="险种" style="margin-bottom: 20px;">
            <div style="margin-bottom: 10px;">
              <a-input-number
                v-model="totalInsuranceType"
                :min="1"
                :max="999"
                placeholder="险种数量"
                style="width: 100px; margin-right: 10px;"
              />
              <a-button @click="generateInsuranceType" type="primary" size="small">生成行</a-button>
            </div>
            <a-table
              :columns="insuranceTypeColumns"
              :dataSource="insuranceTypeData"
              :pagination="false"
              size="small"
              :rowKey="(record, index) => `type_${index}`"
              style="margin-bottom: 15px;">
              <template slot="action" slot-scope="text, record, index">
                <a-button @click="deleteInsuranceTypeRow(index)" type="danger" size="small" icon="delete">删除</a-button>
              </template>
            </a-table>
          </div>

          <!-- 保险公司表格 - 中 -->
          <div class="table-wrapper" v-if="showInsuranceTable" data-title="保险公司" style="margin-bottom: 20px;">
            <div style="margin-bottom: 10px;">
              <a-input-number
                v-model="totalInsurance"
                :min="1"
                :max="999"
                placeholder="保司数量"
                style="width: 100px; margin-right: 10px;"
              />
              <a-button @click="generateInsurance" type="primary" size="small">生成行</a-button>
            </div>
            <a-table
              :columns="insuranceColumns"
              :dataSource="insuranceData"
              :pagination="false"
              size="small"
              :rowKey="(record, index) => `insurance_${index}`"
              style="margin-bottom: 15px;">
              <template slot="action" slot-scope="text, record, index">
                <a-button @click="deleteInsuranceRow(index)" type="danger" size="small" icon="delete">删除</a-button>
              </template>
            </a-table>
          </div>

          <!-- 期数表格 - 下 -->
          <div class="table-wrapper" v-if="showPeriodTable" data-title="期数" style="margin-bottom: 20px;">
            <div style="margin-bottom: 10px;">
              <a-input-number
                v-model="totalPeriods"
                :min="1"
                :max="999"
                placeholder="总期数"
                style="width: 100px; margin-right: 10px;"
              />
              <a-button @click="generatePeriods" type="primary" size="small">生成行</a-button>
            </div>
            <a-table
              :columns="periodColumns"
              :dataSource="periodData"
              :pagination="false"
              size="small"
              :rowKey="(record, index) => `period_${index}`"
              style="margin-bottom: 15px;">
              <template slot="action" slot-scope="text, record, index">
                <a-button @click="deletePeriodRow(index)" type="danger" size="small" icon="delete">删除</a-button>
              </template>
            </a-table>
          </div>
        </a-card>

        <!-- 在执行拆分按钮前添加测试按钮 -->
        <div style="text-align: center; margin-top: 20px;">
          <a-button @click="fillTestData" type="dashed" icon="experiment" style="margin-right: 10px;">填充测试数据</a-button>
          <a-button @click="handleSplit" type="primary" icon="fork">执行拆分</a-button>
        </div>
      </a-tab-pane>

      <!-- 拆分结果显示 -->
      <a-tab-pane tab="拆分结果" key="2" forceRender>
        <div class="table-page-search-wrapper">
          <a-button @click="handleSave" type="primary" icon="save" style="margin-right: 10px;margin-bottom: 20px;">推送到未提交</a-button>
<!--          <a-button @click="handleExport" type="primary" icon="download" style="margin-bottom: 20px;">导出Excel</a-button>-->
        </div>

        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 共拆分出 <a style="font-weight: 600">{{ splitResults.length }}</a> 条业绩数据
          <span style="margin-left: 40px">金额单位：元</span>
          <span style="margin-left: 24px">保额合计：{{ totalInsuredAmount }}</span>
          <span style="margin-left: 24px">保费合计：{{ totalPremium }}</span>
          <span style="margin-left: 24px">去税保费合计：{{ totalCleanPremium }}</span>
          <span style="margin-left: 24px">总佣金合计：{{ totalBrokerageTotal }}</span>
          <span style="margin-left: 24px">净佣金合计：{{ totalInvoiceCleanAmount }}</span>
        </div>

        <!-- 按险种名称统计 -->
        <a-table
          v-if="insuranceTypeSummary.length > 0"
          size="small"
          bordered
          :rowKey="record => record.name"
          :columns="summaryColumns"
          :dataSource="insuranceTypeSummary"
          :pagination="false"
          :rowClassName="record => record.isTotal ? 'summary-total-row' : ''"
          style="margin-bottom: 16px; max-width: 1000px;">
        </a-table>

        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="splitColumns"
          :dataSource="splitResults"
          :pagination="false"
          :loading="tableLoading"
          class="j-table-force-nowrap">
          <span slot="amount" slot-scope="text">
            {{ text }} 元
          </span>
          <template slot="statusSlot" slot-scope="text, record">
            <span>{{getStatus(record)}}</span>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { filterObj, padRightAndFormatter, moneyFormatter } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
import BizBusinessinfoModal from './modules/BizBusinessinfoModal'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import {getAction, postAction} from '@/api/manage'
import JDate from '@/components/jeecg/JDate'
import { mapGetters } from 'vuex'
import JUpload from '@/components/jeecg/JUpload'
import BizBusinessinfoInvoiceForm from './modules/BizBusinessinfoInvoiceForm'
import {NewBusinessTypeDictOptions, AllBusinessTypeDictOptions} from '../enums/businessTypeDictOptions'
import {BusinessStatusDict_Manual, BusinessInfoStatus} from "../enums/BusinessDict"
import ProjectConst from '../project/ProjectConst'
import moment from 'moment'

export default {
  name: "BizAchievementSplit",
  mixins:[mixinDevice],
  components: {
    JSearchSelectTag,
    BizBusinessinfoModal,
    JDate,
    JUpload,
    BizBusinessinfoInvoiceForm
  },
data() {
    return {
      id: null,
      invoiceUnits: [],
      insureDropDownList: new Array(),
      // 投保人失焦带出项目组用：防抖定时器 + 去重标记；提示常驻在投保人输入框下面
      insureBlurTimer: null,
      lastInsureQueried: '',
      insureTip: '',
      businessTypeDict: [],
      // 表头
      splitColumns: [
        {
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },
        {
          title:'业绩编号',
          className:'column-text',
          dataIndex: 'businessNumber',
          sorter: true
        },
        {
          title:'业绩状态',
          align:"center",
          scopedSlots: { customRender: 'statusSlot' }
        },
        {
          title:'业务类型',
          align:"center",
          dataIndex: 'businessType_dictText'
        },
        {
          title:'标的类型',
          align:"center",
          dataIndex: 'productOrLife_dictText'
        },
        /*{
          title:'业绩类型',
          align:"center",
          dataIndex: 'businessPerformanceType_dictText'
        },*/
        {
          title:'项目',
          className:"column-text",
          dataIndex: 'project_dictText'
        },
/*        {
          title:'二级单位',
          className:"column-text",
          dataIndex: 'insureParentOrg_dictText'
        },*/
        {
          title:'经纪人',
          align:"center",
          dataIndex: 'createBy_dictText',
          sorter: true
        },
        {
          title:'部门',
          className:"column-text",
          dataIndex: 'sysOrgCode_dictText',
          sorter: true
        },
        {
          title:'投保人',
          className:"column-text",
          dataIndex: 'insure'
        },
        {
          title:'被保险人',
          className:"column-text",
          dataIndex: 'insured'
        },
        {
          title:'保险人',
          className:"column-text",
          dataIndex: 'insurerNumber_dictText'
        },
        {
          title:'险种类型',
          className:"column-text",
          dataIndex: 'insuranceType_dictText'
        },
        {
          title:'险种名称',
          className:"column-text",
          dataIndex: 'insuranceName'
        },
        {
          title:'车牌号',
          className:'column-text',
          dataIndex: 'car'
        },
        {
          title:'保险起期',
          className:"column-text",
          dataIndex: 'insuranceStart',
          sorter: true,
          customRender:function (text) {
            return !text?"":(text.length>10?text.substr(0,10):text)
          }
        },
        {
          title:'保险讫期',
          className:'column-text',
          dataIndex: 'insuranceEnd',
          sorter: true,
          customRender:function (text) {
            return !text?"":(text.length>10?text.substr(0,10):text)
          }
        },
        {
          title:'保单号',
          className:'column-text',
          dataIndex: 'policy',
          sorter: true
        },
        {
          title:'保额',
          className:'column-money',
          dataIndex: 'insuredAmount',
          customRender:function (text) {
            return !text ? '': text.toLocaleString()
          }
        },
        {
          title:'费率',
          className:'column-money',
          dataIndex: 'rate',
          customRender:function (text) {
            return !text ? '': text + '‰'
          }
        },
        {
          title:'保费',
          className:'column-money',
          dataIndex: 'premium',
          customRender:function (text) {
            return !text ? '': text.toLocaleString()
          }
        },
        {
          title:'去税保费',
          className:'column-money',
          dataIndex: 'cleanPremium',
          customRender:function (text) {
            return !text ? '': text.toLocaleString()
          }
        },
        {
          title:'是否含税',
          align:"center",
          dataIndex: 'includeTax_dictText'
        },
        {
          title:'缴费类型',
          align:"center",
          dataIndex: 'lifeInsurancePayType_dictText'
        },
        {
          title:'佣金比例',
          className:'column-money',
          dataIndex: 'brokerageRatio',
          customRender:function (text) {
            return text == null? '': text + '%'
          }
        },
        {
          title:'总佣金',
          className:'column-money',
          dataIndex: 'brokerageTotal',
          customRender:function (text) {
            return !text ? '': text.toLocaleString()
          }
        },
        {
          title:'净佣金',
          className:'column-money',
          dataIndex: 'invoiceCleanAmount',
          customRender:function (text) {
            return !text ? '': text.toLocaleString()
          }
        },
        {
          title:'发票税率',
          className:'column-money',
          dataIndex: 'taxRate',
        },
        {
          title:'开票单位', //九安、 九安分公司
          className:'column-text',
          dataIndex: 'invoiceUnit_dictText',
        },
        {
          title:'期数',
          align:"center",
          dataIndex: 'phase'
        },
/*        {
          title: '操作',
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:120,
          scopedSlots: { customRender: 'action' }
        }*/
      ],




      // 按险种名称统计的表头
      summaryColumns: [
        {
          title: '险种名称',
          dataIndex: 'name',
          align: 'left'
        },
        {
          title: '总保费',
          dataIndex: 'premium',
          align: 'right',
          customRender: text => (Number(text) || 0).toLocaleString()
        },
        {
          title: '净保费',
          dataIndex: 'cleanPremium',
          align: 'right',
          customRender: text => (Number(text) || 0).toLocaleString()
        },
        {
          title: '总佣金',
          dataIndex: 'brokerageTotal',
          align: 'right',
          customRender: text => (Number(text) || 0).toLocaleString()
        },
        {
          title: '净佣金',
          dataIndex: 'invoiceCleanAmount',
          align: 'right',
          customRender: text => (Number(text) || 0).toLocaleString()
        }
      ],

      labelCol: { xs: { span: 24 }, sm: { span: 6 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 18 } },
      currentBusinessType: '0',
      originalForm: this.$form.createForm(this, {
        onValuesChange: (_, changedValues) => {
          if ('businessType' in changedValues) {
            this.currentBusinessType = changedValues.businessType;
          }
        }
      }),
      splitForm: this.$form.createForm(this),
      tableLoading: false,
      splitResults: [],

      totalPeriods: '',
      totalInsurance: '', // 新增保司数量字段
      totalInsuranceType: '', // 新增险种数量字段

      // 控制表格显示
      showInsuranceTable: true,
      showInsuranceTypeTable: true,
      showPeriodTable: true,

      // 保险公司表格数据
      insuranceData: [
        {
          key: 'insurance_0',
          insuranceCompany: '',
          proportion: '',
          isTax: '1'  // 新增字段
        }
      ],

      // 险种表格数据
      insuranceTypeData: [
        {
          key: 'type_0',
          insuranceType: '',
          typeProportion: '',
          yongjinbili: '',
          isTax: '1' // 添加此字段
        }
      ],

      // 期数表格数据
      periodData: [
        {
          key: 'period_0',
          period: '',
          periodDisplay: '',
          qishubili: '',
          accountDate: null // 新增字段
        }
      ],

// 保险公司表格列配置
      insuranceColumns: [
        {
          title: '保险公司',
          dataIndex: 'insuranceCompany',
          key: 'insuranceCompany',
          width: '55%',
          scopedSlots: { customRender: 'insuranceCompany' },
          customRender: (text, record, index) => (
            <j-search-select-tag
              placeholder="请选择保险公司"
              value={text}
              onChange={(value) => this.handleInsuranceCompanyChange(value, index)}
              onKeydown={(e) => {
                if (e.keyCode === 13 && index === this.insuranceData.length - 1) {
                  this.handleInsuranceEnter(index);
                }
              }}
              dict="biz_insurance_company,name,code"
            />
          )
        },
        {
          title: '保司比例（只写数字，不写百分号%）',
          dataIndex: 'proportion',
          key: 'proportion',
          width: '30%',
          scopedSlots: { customRender: 'proportion' },
          customRender: (text, record, index) => (
            <a-input
              value={text}
              onChange={(e) => this.handleProportionChange(e.target.value, index)}
              onKeydown={(e) => {
                if (e.keyCode === 13 && index === this.insuranceData.length - 1) {
                  this.handleInsuranceEnter(index);
                }
              }}
              placeholder="请输入比例 (回车新增行)"
            />
          )
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '15%'
        }
      ],

      // 险种表格列配置
      insuranceTypeColumns: [
        {
          title: '险种',
          dataIndex: 'insuranceType',
          key: 'insuranceType',
          width: '25%',
          scopedSlots: { customRender: 'insuranceType' },
          customRender: (text, record, index) => (
            <j-search-select-tag
              placeholder="请选择险种"
              value={text}
              onChange={(value) => this.handleInsuranceTypeChange(value, index)}
              onKeydown={(e) => {
                if (e.keyCode === 13 && index === this.insuranceTypeData.length - 1) {
                  this.handleInsuranceTypeEnter(index);
                }
              }}
              dict="biz_insurance_with_type,insurance_name,insurance_name" // 使用实际存在的字段
            />
          )
        },
        {
          title: '保单号',
          dataIndex: 'policy',
          key: 'policy',
          width: '15%',
          scopedSlots: { customRender: 'policy' },
          customRender: (text, record, index) => (
            <a-input
              value={text}
              onChange={(e) => this.handlePolicyChange(e.target.value, index)}
              onKeydown={(e) => {
                if (e.keyCode === 13 && index === this.insuranceTypeData.length - 1) {
                  this.handleInsuranceTypeEnter(index);
                }
              }}
              placeholder="保单号"
            />
          )
        },
        {
          title: '保额',
          dataIndex: 'totalInsuredAmount',
          key: 'totalInsuredAmount',
          width: '12%',
          scopedSlots: { customRender: 'totalInsuredAmount' },
          customRender: (text, record, index) => {
            const formatAmount = (val) => {
              if (val === null || val === undefined || val === '') return '';
              const num = parseFloat(val);
              if (isNaN(num)) return '';
              return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            };
            return (
              <a-input
                value={formatAmount(text)}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/,/g, '');
                  const numValue = rawValue ? parseFloat(rawValue) : null;
                  this.$set(this.insuranceTypeData[index], 'totalInsuredAmount', numValue);
                }}
                placeholder="请输入保额"
                style={{ width: '100%', textAlign: 'right' }}
              />
            );
          }
        },
        {
          title: '保费',
          dataIndex: 'typeProportion',
          key: 'typeProportion',
          width: '10%',
          scopedSlots: { customRender: 'typeProportion' },
          customRender: (text, record, index) => {
            const formatAmount = (val) => {
              if (val === null || val === undefined || val === '') return '';
              const num = parseFloat(val);
              if (isNaN(num)) return '';
              return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            };
            return (
              <a-input
                value={formatAmount(text)}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/,/g, '');
                  const numValue = rawValue ? parseFloat(rawValue) : null;
                  this.$set(this.insuranceTypeData[index], 'typeProportion', numValue);
                }}
                placeholder="请输入保费"
                style={{ width: '100%', textAlign: 'right' }}
              />
            );
          }
        },
        {
          title: '佣金比例',
          dataIndex: 'yongjinbili',
          key: 'yongjinbili',
          width: '8%',
          scopedSlots: { customRender: 'yongjinbili' },
          customRender: (text, record, index) => (
            <a-input
              value={text}
              onChange={(e) => this.handleYongjinbiliChange(e.target.value, index)}
              onKeydown={(e) => {
                if (e.keyCode === 13 && index === this.insuranceTypeData.length - 1) {
                  this.handleInsuranceTypeEnter(index);
                }
              }}
              placeholder="佣金比例"
            />
          )
        },
        {
          title: '保险起期',
          dataIndex: 'insuranceStart',
          key: 'insuranceStart',
          width: '12%',
          scopedSlots: { customRender: 'insuranceStart' },
          customRender: (text, record, index) => (
            <a-date-picker
              value={text ? moment(text) : null}
              onChange={(date, dateStr) => this.handleInsuranceStartChange(date, dateStr, index)}
              placeholder="保险起期"
              style={{ width: '100%' }}
            />
          )
        },
        {
          title: '保险讫期',
          dataIndex: 'insuranceEnd',
          key: 'insuranceEnd',
          width: '12%',
          scopedSlots: { customRender: 'insuranceEnd' },
          customRender: (text, record, index) => (
            <a-date-picker
              value={text ? moment(text) : null}
              onChange={(date, dateStr) => this.handleInsuranceEndChange(date, dateStr, index)}
              placeholder="保险讫期"
              style={{ width: '100%' }}
            />
          )
        },
        {
          title: '是否含税',
          dataIndex: 'isTax',
          key: 'isTax',
          width: '8%',
          scopedSlots: { customRender: 'isTax' },
          customRender: (text, record, index) => (
            <a-select
              value={text === '1' ? '是' : '否'}
              onChange={(value) => this.handleTaxChange(value, index)}
              style={{ width: '100%' }}
            >
              <a-select-option value="1">是</a-select-option>
              <a-select-option value="0">否</a-select-option>
            </a-select>
          )
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '10%'
        }
      ],

      // 期数表格列配置
      periodColumns: [
        {
          title: '期数',
          dataIndex: 'periodDisplay',
          key: 'periodDisplay',
          width: '30%',
          scopedSlots: { customRender: 'periodDisplay' },
          customRender: (text, record, index) => (
            <a-input
              value={text}
              onChange={(e) => this.handlePeriodDisplayChange(e.target.value, index)}
              onKeydown={(e) => {
                if (e.keyCode === 13 && index === this.periodData.length - 1) {
                  this.handlePeriodEnter(index);
                }
              }}
              placeholder="请输入期数"
            />
          )
        },
        {
          title: '期数比例(填写1-100的数字并且不带百分号)',
          dataIndex: 'qishubili',
          key: 'qishubili',
          width: '25%',
          scopedSlots: { customRender: 'qishubili' },
          customRender: (text, record, index) => (
            <a-input
              value={text}
              onChange={(e) => this.handleQishubiliChange(e.target.value, index)}  // 添加变化处理
              onKeydown={(e) => {
                if (e.keyCode === 13 && index === this.periodData.length - 1) {
                  this.handlePeriodEnter(index);
                }
              }}
              placeholder="请输入比例 (回车新增行)"
            />
          )
        },
        {
          title: '核算日期',
          dataIndex: 'accountDate',
          key: 'accountDate',
          width: '30%',
          scopedSlots: { customRender: 'accountDate' },
          customRender: (text, record, index) => (
            <a-date-picker
              value={text ? moment(text) : null}
              onChange={(date, dateStr) => this.handleAccountDateChange(date, dateStr, index)}
              placeholder="核算日期"
              style={{ width: '100%' }}
            />
          )
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '15%'
        }
      ],

      url: {
        split: "/achievement/split/splitByInsurance",
        save: "/achievement/split/saveSplitResults",
        export: "/achievement/split/exportSplitResults",
        getInsureParentOrg: '/biz/customer/getParentOrg',
        getInvoiceUnit: '/sys/sysDepart/getInvoiceUnitByUser',
      }
    }
  },

created() {
      this.initInvoiceUnit()
      // this.newBusinessTypeDictOptions = NewBusinessTypeDictOptions
      this.allBusinessTypeDictOptions = AllBusinessTypeDictOptions
      this.businessTypeDict = NewBusinessTypeDictOptions
      this.businessStatusDict = BusinessStatusDict_Manual
    },

    computed: {
      totalPremium() {
        if (!this.splitResults || this.splitResults.length === 0) return '0.00'
        let total = this.splitResults.reduce((sum, item) => sum + (item.premium || 0), 0)
        return total.toLocaleString()
      },
      totalCleanPremium() {
        if (!this.splitResults || this.splitResults.length === 0) return '0.00'
        let total = this.splitResults.reduce((sum, item) => sum + (item.cleanPremium || 0), 0)
        return total.toLocaleString()
      },
      totalInsuredAmount() {
        if (!this.splitResults || this.splitResults.length === 0) return '0.00'
        let total = this.splitResults.reduce((sum, item) => sum + (item.insuredAmount || 0), 0)
        return total.toLocaleString()
      },
      totalBrokerageTotal() {
        if (!this.splitResults || this.splitResults.length === 0) return '0.00'
        let total = this.splitResults.reduce((sum, item) => sum + (item.brokerageTotal || 0), 0)
        return total.toLocaleString()
      },
      totalInvoiceCleanAmount() {
        if (!this.splitResults || this.splitResults.length === 0) return '0.00'
        let total = this.splitResults.reduce((sum, item) => sum + (item.invoiceCleanAmount || 0), 0)
        return total.toLocaleString()
      },
      // 按险种名称分组统计：总保费、净保费、总佣金、净佣金，末尾追加合计行
      insuranceTypeSummary() {
        if (!this.splitResults || this.splitResults.length === 0) return []
        const round2 = v => Math.round((Number(v) || 0) * 100) / 100
        const map = {}
        this.splitResults.forEach(item => {
          const key = item.insuranceName || '未分类'
          if (!map[key]) {
            map[key] = { name: key, premium: 0, cleanPremium: 0, brokerageTotal: 0, invoiceCleanAmount: 0 }
          }
          map[key].premium            += Number(item.premium) || 0
          map[key].cleanPremium       += Number(item.cleanPremium) || 0
          map[key].brokerageTotal     += Number(item.brokerageTotal) || 0
          map[key].invoiceCleanAmount += Number(item.invoiceCleanAmount) || 0
        })
        const rows = Object.values(map).map(r => ({
          name: r.name,
          premium: round2(r.premium),
          cleanPremium: round2(r.cleanPremium),
          brokerageTotal: round2(r.brokerageTotal),
          invoiceCleanAmount: round2(r.invoiceCleanAmount)
        }))
        // 合计行
        const total = rows.reduce((acc, r) => {
          acc.premium += r.premium
          acc.cleanPremium += r.cleanPremium
          acc.brokerageTotal += r.brokerageTotal
          acc.invoiceCleanAmount += r.invoiceCleanAmount
          return acc
        }, { name: '合计', premium: 0, cleanPremium: 0, brokerageTotal: 0, invoiceCleanAmount: 0, isTotal: true })
        total.premium = round2(total.premium)
        total.cleanPremium = round2(total.cleanPremium)
        total.brokerageTotal = round2(total.brokerageTotal)
        total.invoiceCleanAmount = round2(total.invoiceCleanAmount)
        rows.push(total)
        return rows
      }
    },

    mounted() {
      // 页面加载完成后再设置默认值
      this.$nextTick(() => {
        const currentUser = this.$store.getters.userInfo || {};
        // 使用用户的orgCodeTxt
        const department = currentUser.orgCodeTxt || currentUser.departName || currentUser.departmentName || currentUser.orgCode || '';

this.originalForm.setFieldsValue({
          project: '14', // 项目组默认值
          reportType: '0', // 报送类型默认值
          invoiceUnit: 'A03', // 开票单位默认值
          businessType: '0', // 业务类型默认值-运维
          department: department // 所属部门
        });
      });
    },

  methods: {
      // ...其他方法...
    getStatus(record){
      // 业绩状态 0未提交 1已确认 2已退回 3已匹配
      if (!record || record.status == null) {
        return "未知状态";
      }
      if(record.status == BusinessInfoStatus.UNCONFIRM){
        return "未提交"
      } else if(record.status == BusinessInfoStatus.RETURNED){
        return "已退回"
      } else if(record.status == BusinessInfoStatus.SUBMIT){
        return "已提交"
      } else if(record.status == BusinessInfoStatus.CONFIRMED){
        return "已确认"
      }  else if(record.status == BusinessInfoStatus.MATCHED){
        return "已匹配"
      }
      return "未知状态";
    },
      // 填充测试数据的方法
    fillTestData() {
      // 使用$nextTick确保表单已渲染
      this.$nextTick(() => {
// 填充原始业绩信息
        this.originalForm.setFieldsValue({
          project: '10',
          insure: '久泰能源（准格尔）有限公司',
          insuranceType: '', // 险种类型可选填
          projectInfoId: '1608337487352233985',
          insureParentOrg: '二级单位', // 可根据需要修改
          insuranceStart: moment('2023-01-01'),
          insuranceEnd: moment('2023-12-31'),
          insured: '久泰能源（准格尔）有限公司',
          invoiceUnit: 'A03',
          reportType: '0',
          businessType: '0',
        });
      });

      // 设置拆分设置的显示状态
      this.showInsuranceTable = true;
      this.showPeriodTable = true;
      this.showInsuranceTypeTable = true;
      // 填充保险公司数据 - 使用保险公司code而不是name
      this.totalInsurance = 2;
      this.insuranceData = [
        {
          key: 'insurance_0',
          insuranceCompany: 'RBCXYT', // 中国人民财产保险股份有限公司烟台市分公司的code
          proportion: '50',
        },
        {
          key: 'insurance_1',
          insuranceCompany: 'ZHLHCXSF', // 中华联合财产保险股份有限公司山东分公司的code
          proportion: '50',
        }
      ];

           // 填充期数数据
      this.totalPeriods = 2;
      this.periodData = [
        {
          key: 'period_0',
          period: '1',
          periodDisplay: '1/2',
          qishubili: '50',
          accountDate: moment('2023-01-01')
        },
        {
          key: 'period_1',
          period: '2',
          periodDisplay: '2/2',
          qishubili: '50',
          accountDate: moment('2023-07-01')
        }
      ];

      // 填充险种数据 - 包含起讫期和保额
      this.totalInsuranceType = 2;
      this.insuranceTypeData = [
        {
          key: 'type_0',
          insuranceType: '营业中断险（财产一切险项下）', // 营业中断险（财产一切险项下）的code
          typeProportion: '500000',
          policy: '123456789',
          totalInsuredAmount: '10000000', // 添加总保额
          insuranceStart: moment('2023-01-01'), // 添加保险起期
          insuranceEnd: moment('2023-12-31'),   // 添加保险讫期
          yongjinbili: '10',
          isTax: '1'
        },
        {
          key: 'type_1',
          insuranceType: '机器损坏保险',
          typeProportion: '500000',
          policy: '11111111',
          totalInsuredAmount: '10000000', // 添加总保额
          insuranceStart: moment('2023-01-01'), // 添加保险起期
          insuranceEnd: moment('2024-12-31'),   // 添加保险讫期
          yongjinbili: '10',
          isTax: '0'
        }
      ];

      this.$message.success('测试数据已填充完成！');
    },

      initInvoiceUnit() {
        this.invoiceUnits = []
        //根据当前登录用户获取能选择的开票单位
        getAction(this.url.getInvoiceUnit, {}).then((res) => {
          if (res.success) {
            this.invoiceUnits = res.result
          }
        })
      },

    // 佣金比例输入框变化处理
    handleYongjinbiliChange(value, index) {
      this.insuranceTypeData[index].yongjinbili = value;
    },
    insureChange(item){
      this.insureValue =  item;
      this.insureDropDownList = [];
      this.originalForm.setFieldsValue({insure: item});
      // 选中下拉项时 blur 已经先触发过，取消它那次用半截名字发起的查询
      clearTimeout(this.insureBlurTimer);
      // 自动设置被保险人与投保人相同
      this.originalForm.setFieldsValue({insured: item});

      // 直接调用 blur 事件的处理方法
      // 创建一个模拟的事件对象
      const mockEvent = { target: { value: item } };
      this.getInsureParentOrg(mockEvent);
    },
    insureInputFocus(){
      this.insureDropDownList = [];
    },
    // 投保人失焦即重新带出项目组、立项名称、二级单位。
    // 手输投保人且匹配到多个客户时不会走 insureChange，只有这里能保证改了投保人项目组跟着变。
    // 点下拉项时浏览器先触发 blur、后触发 click，所以延迟一下等 insureChange 填完整名称。
    insureBlur(e){
      const typed = e && e.target ? e.target.value : '';
      clearTimeout(this.insureBlurTimer);
      this.insureBlurTimer = setTimeout(() => {
        const value = this.originalForm.getFieldValue('insure') || typed;
        this.getInsureParentOrg({ target: { value: value } });
      }, 300);
    },
    insureInput(e){
      clearTimeout(this.timer);
      this.timer = setTimeout(()=>{
        this.insureSearch(e.target.value)
      }, 1000);
    },
    insureSearch(v){
      this.insureDropDownList = [];
      if(v.length>1){
        // 关键字过滤与限量交给后端，避免每次输入都全量拉取客户档案
        getAction('/sys/dict/loadDict/biz_customer,name,name', {keyword: v, pageSize: 20}).then((res) => {
          if (res.success) {
            this.insureDropDownList = res.result.map((item) => item['text']);
            // 当只有一个匹配项时，自动填充到输入框
            if (this.insureDropDownList.length === 1) {
              this.insureChange(this.insureDropDownList[0]);
            }
          }
        })
      }
    },
    async getInsureParentOrg (event) {
      const value = event.target.value; // 获取输入框的值
      if (!value) return; // 如果没有输入，则不触发校验
      if (value === this.lastInsureQueried) return; // 投保人没变，不重复查
      this.lastInsureQueried = value;

      try {
        const res = await postAction(`${this.url.getInsureParentOrg}?customerName=${value}`);
        // 判断返回结果
        if (res.success && res.result) {
          this.insureTip = ''
          // 更新表单中的险种类型字段
          this.originalForm.setFieldsValue({ insureParentOrg: res.result.customerId });
          //项目组
          this.originalForm.setFieldsValue({ project: res.result.projectGroupId });
          //项目明细
          this.originalForm.setFieldsValue({ projectInfoId: res.result.projectId });
        } else {
          // 查不到投保人对应的立项。只把原因常驻提示在投保人输入框下面，
          // 不清空项目组和立项名称 —— 合作、其他这类业务的投保人绝大多数都没有立项，
          // 清空会把用户手选的项目组反复抹掉，且后端对非运维业务本就不做匹配校验。
          this.insureTip = res.message || '未找到该投保人对应的立项，请联系运营部确认'
        }
      } catch (error) {
        // 捕获请求异常
        console.error('查找上级机构时发生错误:', error);
        this.insureTip = '查询投保人对应的立项失败，请稍后重试'
      }
    },



    // 生成期数数据
    generatePeriods() {
      if (!this.totalPeriods || this.totalPeriods <= 0) {
        this.$message.warning('请输入有效的总期数');
        return;
      }

      // 获取原始表单中的保险起期作为默认核算日期
      const formData = this.originalForm.getFieldsValue();
      const defaultAccountDate = formData.insuranceStart || null;

      const periods = [];
      for (let i = 1; i <= this.totalPeriods; i++) {
        periods.push({
          key: `period_${i-1}`,
          period: i.toString(),
          periodDisplay: `${i}/${this.totalPeriods}`,
          qishubili: '',
          accountDate: defaultAccountDate // 默认使用保险起期
        });
      }
      this.periodData = periods;
    },

    handleTaxChange(value, index) {
      // 确保修改正确
      this.insuranceTypeData[index].isTax = value;
    },

    // 切换险种表格显示/隐藏
    toggleInsuranceTypeTable() {
      this.showInsuranceTypeTable = !this.showInsuranceTypeTable;
      if (!this.showInsuranceTypeTable) {
        // 隐藏表格时重置数据
        this.totalInsuranceType = '';
        this.insuranceTypeData = [
          {
            key: 'type_0',
            insuranceType: '',
            typeProportion: '',
            yongjinbili: '',
          isTax: '1'
          }
        ];
      }
    },

    // 切换期数表格显示/隐藏
    togglePeriodTable() {
      this.showPeriodTable = !this.showPeriodTable;
      if (!this.showPeriodTable) {
        // 隐藏表格时重置数据
        this.totalPeriods = '';
        this.periodData = [
          {
            key: 'period_0',
            period: '',
            periodDisplay: '',
            qishubili: '',
            accountDate: null
          }
        ];
      }
    },

    // 回车触发增加保险公司行
    handleInsuranceEnter(index) {
      if (index === this.insuranceData.length - 1) {
        this.addInsuranceRow();
      }
    },

    // 回车触发增加险种行
    handleInsuranceTypeEnter(index) {
      if (index === this.insuranceTypeData.length - 1) {
        this.addInsuranceTypeRow();
      }
    },

    // 回车触发增加期数行
    handlePeriodEnter(index) {
      if (index === this.periodData.length - 1) {
        this.addPeriodRow();
      }
    },

    // 添加保险公司行
    addInsuranceRow() {
      const newKey = `insurance_${this.insuranceData.length}`;
      this.insuranceData.push({
        key: newKey,
        insuranceCompany: '',
        proportion: '',
      });
    },

    // 删除保险公司行
    deleteInsuranceRow(index) {
      if (this.insuranceData.length > 1) {
        this.insuranceData.splice(index, 1);
      } else {
        this.$message.warning('至少保留一行');
      }
    },

    // 保险公司输入框变化处理
    handleInsuranceCompanyChange(value, index) {
      this.insuranceData[index].insuranceCompany = value;
    },

    // 保司比例输入框变化处理
    handleProportionChange(value, index) {
      this.insuranceData[index].proportion = value;
    },

    // 险种保单号输入框变化处理
    handlePolicyChange(value, index) {
      this.insuranceTypeData[index].policy = value;
    },

    // 险种保险起期变化处理
    handleInsuranceStartChange(date, dateStr, index) {
      if (date) {
        this.$set(this.insuranceTypeData[index], 'insuranceStart', date);
      } else {
        this.$set(this.insuranceTypeData[index], 'insuranceStart', null);
      }
    },

    // 险种保险讫期变化处理
    handleInsuranceEndChange(date, dateStr, index) {
      if (date) {
        this.$set(this.insuranceTypeData[index], 'insuranceEnd', date);
      } else {
        this.$set(this.insuranceTypeData[index], 'insuranceEnd', null);
      }
    },

    // 核算日期变化处理
    handleAccountDateChange(date, dateStr, index) {
      if (date) {
        this.$set(this.periodData[index], 'accountDate', date);
      } else {
        this.$set(this.periodData[index], 'accountDate', null);
      }
    },

    // 总保额输入框变化处理
    handleTotalInsuredAmountChange(value, index) {
      this.insuranceTypeData[index].totalInsuredAmount = value;
    },

    // 添加险种行
    addInsuranceTypeRow() {
      const newKey = `type_${this.insuranceTypeData.length}`;
      this.insuranceTypeData.push({
        key: newKey,
        insuranceType: '',
        typeProportion: '',
        yongjinbili: '',
        isTax: '1' // 添加是否含税字段，默认值为"是"
      });
    },

    // 删除险种行
    deleteInsuranceTypeRow(index) {
      if (this.insuranceTypeData.length > 1) {
        this.insuranceTypeData.splice(index, 1);
      } else {
        this.$message.warning('至少保留一行');
      }
    },

    // 险种输入框变化处理
    handleInsuranceTypeChange(value, index) {
      this.insuranceTypeData[index].insuranceType = value;
    },

    // 险种比例输入框变化处理
    handleInsuranceTypeProportionChange(value, index) {
      this.insuranceTypeData[index].typeProportion = value;
    },

    // 添加期数行
    addPeriodRow() {
      // 获取原始表单中的保险起期作为默认核算日期
      const formData = this.originalForm.getFieldsValue();
      const defaultAccountDate = formData.insuranceStart || null;

      const newKey = `period_${this.periodData.length}`;
      this.periodData.push({
        key: newKey,
        period: '',
        qishubili: '',
        accountDate: defaultAccountDate // 默认使用保险起期
      });
    },

    // 删除期数行
    deletePeriodRow(index) {
      if (this.periodData.length > 1) {
        this.periodData.splice(index, 1);
      } else {
        this.$message.warning('至少保留一行');
      }
    },

    // 修改期数输入框变化处理
    handlePeriodDisplayChange(value, index) {
      this.periodData[index].period = value;
      // 更新显示值
      if (this.totalPeriods) {
        this.periodData[index].periodDisplay = `${value}/${this.totalPeriods}`;
      } else {
        this.periodData[index].periodDisplay = value;
      }
    },

    // 期数比例输入框变化处理
    handleQishubiliChange(value, index) {
      this.periodData[index].qishubili = value;
    },

    handleSplit() {
      const that = this;

      // 验证表单
      that.originalForm.validateFields((err, values) => {
        if (err) {
          this.$message.warning('请完善原始业绩信息');
          return;
        }

        // 运维业务类型必须填写立项名称
        if (values.businessType === '0' && !values.projectInfoId) {
          this.$message.warning('运维类型业务必须填写立项名称');
          return;
        }

        // 检查二级单位是否为placeholder文本，如果是则设置为空值
        if (values.insureParentOrg && (values.insureParentOrg.includes('请选择') || values.insureParentOrg.includes('请输入'))) {
          values.insureParentOrg = '';
        }

        // 验证保费是否为正数
        if (values.insuredAmount !== undefined && values.insuredAmount <= 0) {
          this.$message.warning('总保额必须大于0');
          return;
        }

        // 验证期数是否已填写
        if (!this.showPeriodTable || !this.periodData || this.periodData.length === 0) {
          this.$message.warning('期数至少要填写一期');
          return;
        }

        // 验证期数数据是否有效
        const validPeriodData = this.periodData.filter(item => item.period && item.period.trim() !== '');
        if (validPeriodData.length === 0) {
          this.$message.warning('期数至少要填写一期');
          return;
        }

        // 处理险种表格中的日期字段，转换为字符串格式
        const processedInsuranceTypeData = this.insuranceTypeData.map(item => ({
          ...item,
          insuranceStart: item.insuranceStart ? (item.insuranceStart.format ? item.insuranceStart.format('YYYY-MM-DD') : item.insuranceStart) : null,
          insuranceEnd: item.insuranceEnd ? (item.insuranceEnd.format ? item.insuranceEnd.format('YYYY-MM-DD') : item.insuranceEnd) : null,
          accountDate: item.accountDate ? (item.accountDate.format ? item.accountDate.format('YYYY-MM-DD') : item.accountDate) : null
        }));

        // 处理期数表格中的日期字段
        const processedPeriodData = this.periodData.map(item => ({
          ...item,
          accountDate: item.accountDate ? (item.accountDate.format ? item.accountDate.format('YYYY-MM-DD') : item.accountDate) : null
        }));

        // 执行拆分
        that.tableLoading = true;
        let params = {
          originalData: values,
          insuranceData: this.insuranceData,
          insuranceTypeData: this.showInsuranceTypeTable ? processedInsuranceTypeData : [],
          periodData: this.showPeriodTable ? processedPeriodData : []
        };

        postAction(that.url.split, params).then((res) => {
          if (res.success) {
            // 确保 splitResults 是数组格式
            that.splitResults = res.result ? res.result.records : [];
            // 切换到拆分结果tab
            that.$nextTick(() => {
              that.$el.querySelector('.ant-tabs-tab:nth-child(2)').click();
            });
          } else {
            that.$message.error(res.message);
          }
        }).finally(() => {
          that.tableLoading = false;
        });
      });
    },

    handleSave() {
      if (this.splitResults.length === 0) {
        this.$message.warning('没有可保存的数据');
        return;
      }

      const that = this;
      this.$confirm({
        title: '确认保存',
        content: `确定要将这 ${this.splitResults.length} 条拆分后的业绩推送到未提交吗？`,
        onOk() {
          return new Promise((resolve, reject) => {
            postAction(that.url.save, that.splitResults).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                resolve();
              } else {
                that.$message.error(res.message);
                reject();
              }
            }).catch(() => {
              reject();
            });
          });
        }
      });
    },

    handleExport() {
      if (this.splitResults.length === 0) {
        this.$message.warning('没有可导出的数据');
        return;
      }

      // 实现导出逻辑
      this.$message.info('正在导出...');
      // 可以调用导出接口或使用前端导出库
      window.location.href = `${window._CONFIG['domianURL']}${this.url.export}`;
    },

    // 生成保司数据
    generateInsurance() {
      if (!this.totalInsurance || this.totalInsurance <= 0) {
        this.$message.warning('请输入有效的保司数量');
        return;
      }

      const insurances = [];
      for (let i = 1; i <= this.totalInsurance; i++) {
        insurances.push({
          key: `insurance_${i-1}`,
          insuranceCompany: '',
          proportion: '',
          isTax: '1'
        });
      }
      this.insuranceData = insurances;
    },

  // 生成险种数据
  generateInsuranceType() {
    if (!this.totalInsuranceType || this.totalInsuranceType <= 0) {
      this.$message.warning('请输入有效的险种数量');
      return;
    }

    // 获取原始表单中的保险起讫期
    const formData = this.originalForm.getFieldsValue();
    const originalStartDate = formData.insuranceStart || null;
    const originalEndDate = formData.insuranceEnd || null;

    const types = [];
    for (let i = 1; i <= this.totalInsuranceType; i++) {
      types.push({
        key: `type_${i-1}`,
        insuranceType: '',
        typeProportion: '',   // 保费
        policy: '',           // 保单号
        insuranceStart: originalStartDate,  // 默认使用原始业绩的保险起期
        insuranceEnd: originalEndDate,      // 默认使用原始业绩的保险讫期
        yongjinbili: '',   // 佣金比例
        isTax: '1'
      });
    }

    this.insuranceTypeData = types;

  },

  }
}
</script>

/* 主承单选框样式 */
.mainInsurerRadio {
  cursor: pointer;
}

/* 保险公司下拉框样式 */
.jSearchSelectTag {
  z-index: 1;
}

/* 保险公司表格样式 */
.insuranceTable .ant-table-tbody > tr > td {
  position: relative;
}

.tables-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.table-wrapper {
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
  background-color: #fafafa;
  width: 100%;
  max-width: 1500px;
}
}

/* 保险公司表格 */
.table-wrapper[data-title="保险公司"] {
  /* 样式已在行内设置 */
}

/* 险种表格 */
.table-wrapper[data-title="险种"] {
  /* 样式已在行内设置 */
}

/* 期数表格 */
.table-wrapper[data-title="期数"] {
  /* 样式已在行内设置 */
}

/* 表格标题样式 - 修复并添加浅蓝背景 */
.table-wrapper::before {
  content: attr(data-title);
  display: block;
  font-weight: bold;
  margin: -10px -10px 10px -10px; /* 负边距让它扩展到边框边缘 */
  color: #333;
  border-bottom: 1px solid #d9d9d9;
  padding: 8px 10px 5px 10px; /* 调整内边距 */
  background-color: #e6f7ff; /* 浅蓝色背景 */
  border-radius: 4px 4px 0 0; /* 左上角和右上角圆角 */
}

/* 修改删除按钮文字颜色 */
.ant-btn-danger {
  color: #000 !important;
}

/* 险种统计合计行高亮 */
.summary-total-row {
  background-color: #fafafa;
  font-weight: 600;
}

/* 在较小屏幕上调整为单列显示 */
@media (max-width: 768px) {
  .tables-container {
    gap: 15px;
  }

  .table-wrapper {
    max-width: none;
  }

  /* 移动端调整标题负边距 */
  .table-wrapper::before {
    margin: -10px -10px 10px -10px;
  }
}
</style>